const $ = jQuery.noConflict();

'use strict';
const Footer = {
	init: function() {
		if (window.innerWidth < 768) {
			$('.js-mobile-accordion-btn').on('click', function() {
				const accordion = $(this).closest('.js-acc-item');
				const content = accordion.find('.js-mobile-accordion-content');

				if (content.css('max-height') !== '0px') {
					closeAccordion(accordion);
				} else {
					closeAllAccordions();
					openAccordion(accordion);
				}
			});
		}

		function openAccordion(accordion) {
			const content = accordion.find('.js-mobile-accordion-content');
			accordion.addClass('active');
			content.css('max-height', content[0].scrollHeight + 'px');
		}

		function closeAccordion(accordion) {
			const content = accordion.find('.js-mobile-accordion-content');
			accordion.removeClass('active');
			content.css('max-height', '0');
		}

		function closeAllAccordions() {
			$('.js-acc-item').each(function() {
				closeAccordion($(this));
			});
		}
	},
};

export default Footer;
